/**
 * Theme Toggle Component
 * Allows users to switch between light, dark, and system themes
 */

import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { FaSun, FaMoon, FaDesktop } from 'react-icons/fa';
import { cn } from '../lib/utils';

const ThemeToggle = ({ variant = 'default' }) => {
  const { theme, setTheme } = useTheme();

  const themes = [
    { id: 'light', icon: <FaSun />, label: 'Light' },
    { id: 'dark', icon: <FaMoon />, label: 'Dark' },
    { id: 'system', icon: <FaDesktop />, label: 'System' },
  ];

  if (variant === 'compact') {
    const currentTheme = themes.find(t => t.id === theme);
    return (
      <button
        className="p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-800 transition-colors"
        onClick={() => {
          const currentIndex = themes.findIndex(t => t.id === theme);
          const nextIndex = (currentIndex + 1) % themes.length;
          setTheme(themes[nextIndex].id);
        }}
        title={`Current: ${currentTheme?.label}. Click to change.`}
      >
        {currentTheme?.icon}
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">Theme</span>
      <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-0.5">
        {themes.map((t) => (
          <button
            key={t.id}
            className={cn(
              'p-1.5 rounded-md transition-colors',
              theme === t.id
                ? 'bg-white dark:bg-gray-700 text-green-600 shadow-sm'
                : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200'
            )}
            onClick={() => setTheme(t.id)}
            title={t.label}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              {t.icon}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeToggle;
